<div class="container-fluid px-2 px-md-4 py-3">
  <ng-container *ngIf="isLoading; else pageContent">
    <div class="app-spinner flex-column">
      <mat-spinner diameter="60"></mat-spinner>
      <p class="mt-3 text-secondary fw-medium" *ngIf="loadingTitle">{{ loadingTitle }}</p>
    </div>
  </ng-container>

  <ng-template #pageContent>
    <!-- <div class="mb-4" *ngIf="roadmap">
      <div class="d-flex justify-content-between align-items-center">
        <div class="d-flex">
       

          <div>
            <h5 class="fw-medium">{{ roadmap.title }}</h5>
            <small class="text-muted">
              {{ totalCompletedSubtopics }} / {{ roadmap.stats?.total_subtopics || 0 }}steps
              completed
            </small>
          </div>
        </div>
        <div class="d-flex align-items-center gap-2">
          <div class="d-flex align-items-center gap-3">
            <div class="dropdown">
              <button class="btn border rounded share-btn fw-medium text-black btn-sm dropdown-toggle" type="button"
                data-bs-toggle="dropdown" aria-expanded="false">

                <i class="bi bi-share"></i> Share
              </button>

              <ul class="dropdown-menu dropdown-menu-end shadow-sm">
                <li>
                  <a class="dropdown-item share-btn px-2  rounded" (click)="copyLink()">
                    <i class="bi bi-copy"></i> Copy Link
                  </a>
                  <hr>
                </li>

                <li>
                  <a class="dropdown-item share-btn px-2  rounded" (click)="exportToPDF()">
                    <i class="bi bi-file-pdf"></i> Export PDF
                  </a>
                </li>
              </ul>
            </div>

          </div>

          <div class="mat-circle-wrapper">
            <mat-progress-spinner mode="determinate" [value]="overallProgress" diameter="48"
              strokeWidth="4"></mat-progress-spinner>

            <span>{{ overallProgress }}%</span>
          </div>
        </div>
      </div>


    </div> -->

    <div class="roadmap-summary-card card px-4 py-3 mb-4 gradient-header">
      <!-- Top Row -->
      <div class="d-flex justify-content-between align-items-start">
        <div>
          <!--  <span class="status-chip  border rounded-pill px-2" [ngClass]="{
        'status-not-started': getRoadmapStatus() === 'Not Started',
        'status-in-progress': getRoadmapStatus() === 'In Progress',
        'status-done': getRoadmapStatus() === RoadmapProgressStatus.DONE
      }">
            {{ getRoadmapStatus() }}
          </span> -->
          <div class="d-flex align-items-center gap-2">
            <span class="me-2"><i (click)="goBack()" class="back-link backButton bi bi-arrow-left px-3 py-2"></i></span>

            <h4 class="fw-semibold mt-2">{{ roadmap.title }}</h4>
          </div>

          <small class="text-muted mb-3">
            {{ roadmap.description }}
          </small>
        </div>
      </div>

      <!-- Overall Progress -->
      <div class="d-flex justify-content-between align-items-center mt-4">
        <span class="fw-small">Overall Progress</span>
        <small class="text-muted small">
          {{ totalCompletedSubtopics }} of {{ roadmap.stats?.total_subtopics || 0 }} subtopics
          completed
        </small>
      </div>

      <div class="progress mt-2 mb-3" style="height: 10px">
        <div class="progress-bar progress-bar-custom" [style.width.%]="overallProgress"></div>
      </div>

      <div class="d-flex flex-wrap gap-2 mb-3">
        <small class="meta-pill border text-black  border rounded-pill px-2 py-1"> <i class="bi bi-book"></i> {{
          roadmap.topics.length || 0 }} Topics </small>
        <small class="meta-pill border text-black  border rounded-pill px-2 py-1"> <i class="bi bi-file-bar-graph"></i>
          {{ roadmap.stats?.total_subtopics || 0 }} Subtopics
        </small>
        <span class="meta-pill">
          <!-- {{ roadmap.duration }} -->
        </span>
      </div>

      <div class="d-flex flex-wrap gap-2">
        <small class="difficulty-pill border  border rounded-pill px-2"
          *ngFor="let item of (roadmap.stats?.difficulty_distribution || {}) | keyvalue" [ngClass]="{
          beginner: item.key === 'BEGINNER',
          intermediate: item.key === 'INTERMEDIATE',
          advanced: item.key === 'ADVANCED',
        }">
          {{ item.key }}:{{ item.value }}
        </small>
      </div>
    </div>
    <div *ngIf="roadmap && !hasRoadmapStarted()"
      class="start-journey-box d-flex align-items-center gap-3 mb-4 px-4 py-4 rounded">
      <div class="start-journey-icon flex-shrink-0">
        <i class="bi bi-rocket-takeoff-fill"></i>
      </div>
      <div class="flex-grow-1">
        <p class="fw-semibold mb-0">Start your learning journey today</p>
        <small class="text-secondary">Click on any subtopic circle to begin tracking your progress</small>
      </div>
    </div>

    <div *ngIf="roadmap && hasRoadmapStarted()"
      class="resume-box d-flex align-items-center gap-3 mb-4 px-3 py-2 border rounded shadow-sm resume-section justify-content-between">
      <div class="resume-icon d-flex align-items-center me-3 gap-3">
        <i class="bi bi-play-fill icon"></i>
        <div>
          <small class="text-secondary font-name">Continue where you left off</small>
          <br>
          <small class="mb-0 fw-small font-name">{{ currentTopicTitle }}</small>
          <br *ngIf="currentSubtopicTitle">
          <small class="text-secondary font-name" *ngIf="currentSubtopicTitle">{{ currentSubtopicTitle }}</small>
        </div>
      </div>

      <div>
        <button class="btn" (click)="resumeLastStep()">
          Resume <i class="bi bi-arrow-right-short"></i>
        </button>
      </div>
    </div>

    <div *ngIf="roadmap" class="accordion rounded accordion-flush" id="accordionFlushExample">
      <div class="accordion-item mb-3 shadow-sm" *ngFor="let topic of roadmap.topics; let i = index"
        [ngClass]="'topic-status-' + (topicStatsMap[topic.topic_id]?.status || 'PENDING').toLowerCase().replace('_', '-')">
        <!-- HEADER -->
        <h2 class="accordion-header" [id]="'flush-heading-' + i">
          <button
            class="accordion-button rounded d-flex align-items-center justify-content-between border-bottom flex-wrap"
            type="button" [class.collapsed]="openPhaseIndex !== i" (click)="togglePhase(i)">
            <div class="d-flex gap-2 flex-grow-1" style="min-width: 0">

              <div class="step-status-icon phase-number-icon flex-shrink-0 position-relative" [ngClass]="{
                'phase-completed': topicStatsMap[topic.topic_id]?.progress === 100,
              }">
                <i class="bi bi-check-lg me-3 text-white" *ngIf="topicStatsMap[topic.topic_id]?.progress === 100"
                  style="font-size: 16px;"></i>
                <span class="step-number text-black" *ngIf="topicStatsMap[topic.topic_id]?.progress !== 100">
                  {{ i + 1 }}
                </span>
              </div>

              <div style="min-width: 0; flex: 1;font-family: 'Poppins', sans-serif;">
                <div class="d-flex align-items-center gap-2 flex-wrap">
                  <span class="fw-medium ms-2">{{ topic.title }}</span>
                  <span class="badge rounded-pill px-2 py-1 fw-normal" [ngClass]="{
                    'bg-success-subtle text-success border border-success-subtle': (topicStatsMap[topic.topic_id]?.status || 'PENDING') === 'DONE' || (topicStatsMap[topic.topic_id]?.status || 'PENDING') === 'COMPLETED',
                    'bg-info-subtle text-info border border-info-subtle': (topicStatsMap[topic.topic_id]?.status || 'PENDING') === 'IN_PROGRESS',
                    'bg-secondary-subtle text-secondary border border-secondary-subtle': (topicStatsMap[topic.topic_id]?.status || 'PENDING') === 'PENDING'
                  }" style="font-size: 10px;">
                    {{ (topicStatsMap[topic.topic_id]?.status || 'PENDING') | titlecase }}
                  </span>
                </div>

                <div class="">
                  <div class="my-2">
                    <div class="d-flex gap-2 my-2 flex-wrap">
                      <small class="text-muted"><i class="bi bi-clock pe-1 ms-2"></i>{{
                        topic.estimated_total_time }}</small>
                      <small class="text-muted ">
                        {{ topicStatsMap[topic.topic_id]?.completedSteps || 0 }} /
                        {{ topicStatsMap[topic.topic_id]?.totalSteps || 0 }} subtopics
                      </small>

                    </div>
                    <div class="progress mb-2" style="height: 6px; max-width: 300px; min-width: 100px">
                      <div class="progress-bar progress-bar-custom"
                        [style.width.%]="topicStatsMap[topic.topic_id]?.progress || 0"></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </button>
        </h2>
        <div class="accordion-collapse" [class.show]="openPhaseIndex === i" 
        [style.display]="openPhaseIndex === i ? 'block' : 'none'">          <div class="accordion-body p-0">
            <div class="align-items-start gap-3 p-3 step-row d-flex" *ngFor="let sub of topic.subtopics; let si = index"
              [class.completed-bg]="progressMap.get(sub.subtopic_id) === RoadmapProgressStatus.DONE">

              <div class="status-icon-container">
                <div class="status-circle" [ngClass]="{
                'completed': progressMap.get(sub.subtopic_id) === RoadmapProgressStatus.DONE,
                'in-progress': progressMap.get(sub.subtopic_id) === RoadmapProgressStatus.IN_PROGRESS,
                'pending': progressMap.get(sub.subtopic_id) !== RoadmapProgressStatus.DONE
             }" (click)="startLearning($event, topic.topic_id, sub)">
                  <i class="bi bi-check-lg" *ngIf="progressMap.get(sub.subtopic_id) === RoadmapProgressStatus.DONE"></i>
                  <i class="bi bi-arrow-repeat spin-icon"
                    *ngIf="progressMap.get(sub.subtopic_id) === RoadmapProgressStatus.IN_PROGRESS"></i>
                </div>
              </div>

              <div #subtopicElement class="flex-grow-1 cursor-pointer" [attr.data-id]="sub.subtopic_id"
                (click)="toggleSubtopic(sub)">
                <div class="d-flex align-items-start justify-content-between gap-2">
                  <div class="d-flex flex-column" style="min-width:0; flex:1;font-family: 'Poppins', sans-serif;">
                    <div class="d-flex align-items-center gap-2 flex-wrap">
                      <span class="mb-0 fw-medium subtopic-title"
                      
                        [class.completed-text]="progressMap.get(sub.subtopic_id) === RoadmapProgressStatus.DONE">
                        {{ sub.title }}
                      </span>
                      <span class="badge rounded-pill px-2 py-1 fw-normal flex-shrink-0" [ngClass]="{
                  'bg-success-subtle text-success border border-success-subtle': sub.difficulty === 'BEGINNER',
                  'bg-warning-subtle text-warning border border-warning-subtle': sub.difficulty === 'INTERMEDIATE',
                  'bg-danger-subtle text-danger border border-danger-subtle': sub.difficulty === 'ADVANCED'
                }">
                        {{ sub.difficulty | titlecase }}
                      </span>
                    </div>
                    <small class="text-secondary small mb-0"><i class="bi bi-clock pe-1 ms-2"></i>{{ sub.estimated_time
                      }}</small>
                  </div>
                  <div class="d-flex align-items-center gap-2 flex-shrink-0">
                    <i class="bi"
                      [ngClass]="openSubTopic === sub.subtopic_id ? 'bi-chevron-down' : 'bi-chevron-right'"></i>
                  </div>
                </div>


                <div *ngIf="openSubTopic === sub.subtopic_id" class="mt-3" (click)="$event.stopPropagation()">
                  <div class="font-name">
                    <h6 class="fw-semibold mb-2">Description</h6>
                    <p class="text-muted small">{{ sub.description }}</p>
                  </div>
                  <div class="subtopic-details font-name">


                    <div *ngIf="sub.examples && sub.examples.length > 0" class="mt-4">
                      <h6 class="fw-semibold mb-3 d-flex align-items-center gap-2">
                        <i class="bi bi-lightbulb text-warning"></i>Examples
                      </h6>

                      <div class="" *ngFor="let ex of sub.examples">
                        <div class="example-card mb-4  bg-muted-subtle border border-light-subtle rounded-4 shadow-sm">

                          <div class="d-flex justify-content-between align-items-center mb-2 px-2 py-2 border-bottom"
                            *ngIf="ex.code">
                            <small class="text-uppercase fw-bold text-muted extra-small">{{ex.title}}</small>

                          </div>


                          <pre *ngIf="ex.code" class="code-block p-3 rounded-3 mb-3"><code>{{ ex.code }}</code></pre>
                          <div *ngIf="ex.scenario" class="mt-3 p-2 px-3 bg-light rounded-3  border-primary border-3">
                            <small class="fw-bold d-block mb-1">Scenario:</small>
                            <small class="text-muted">{{ ex.scenario }}</small>
                          </div>
                        </div>
                        <div class="mb-2">
                          <small class="text-secondary small mb-0">{{ ex.explanation }}</small>
                        </div>
                      </div>

                    </div>
                  </div>

                  <div *ngIf="sub.reference_links && sub.reference_links.length > 0" class="pt-3 border-top">
                    <h6 class="fw-medium text-black mb-2 d-flex align-items-center gap-2">
                      <i class="bi bi-link-45deg text-primary"></i> Resources
                    </h6>
                    <ul class="list-unstyled mb-0 d-flex flex-wrap align-items-center gap-2">
                      <li *ngFor="let link of sub.reference_links" class="mb-2">
                        <a [href]="link" target="_blank" style="background: #e9e9e9;"
                          class="text-decoration-none border rounded-pill px-2 py-1 text-black bg-muted-subtle gap-1 d-flex align-items-center gap-2 small">
                          <span class="text-truncate" style="max-width: 90%;">{{ link | slice:0:20}}{{link.length > 40 ?
                            '...' : ''}}</span>
                          <i class="bi bi-box-arrow-up-right x-small"></i>
                        </a>
                      </li>
                    </ul>
                  </div>
                  <div class="d-flex gap-2 border-top pt-3 align-items-center justify-content-end">

                    <ng-container *hasPermission="PermissionForStudents.ROADMAP_TRACK">
                      <button *ngIf="progressMap.get(sub.subtopic_id) !== RoadmapProgressStatus.DONE"
                        class="markAsCompletebtn" (click)="markSubtopicComplete($event, topic.topic_id, sub)">
                        <i class="bi bi-check-circle"></i> Mark as Completed
                      </button>

                      <div *ngIf="progressMap.get(sub.subtopic_id) === RoadmapProgressStatus.DONE"
                        class="markasIncompleteBtn d-flex align-items-center gap-2">
                        <i class="bi bi-check-circle-fill"></i> Completed
                      </div>

                      <button *ngIf="progressMap.get(sub.subtopic_id) === RoadmapProgressStatus.DONE"
                        class="reset-btn text-secondary" (click)="resetSubtopic($event, topic.topic_id, sub)">
                        Reset
                      </button>
                    </ng-container>
                  </div>

                </div>
              </div>

              <hr class="mt-3 mb-0 border-light" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </ng-template>

</div>
<!-- 
<div class="custom-backdrop" *ngIf="isDrawerOpen" (click)="closeDrawer()"></div>

<div class="custom-drawer" [class.open]="isDrawerOpen">
   <div class="drawer-header border-bottom my-2 d-flex align-items-center px-3 py-3"> 
    <div class="step-icon me-2" [ngClass]="{ 'icon-completed': selectedStep?.completed }">
      <i class="bi" [ngClass]="
            selectedStep?.completed ? 'bi-check-circle-fill' : 'bi-bullseye'
          "></i>
    </div>

    <h5 class="flex-grow-1 fw-medium fs-6">
      <small class="mb-1 text-black d-inline-block px-2 text-muted border rounded-pill">
        Practice
      </small>
      <br />
      {{ selectedStep?.title }}
    </h5>

    <button class="btn-close" (click)="closeDrawer()"></button>
  </div> 

  <div class="drawer-body" *ngIf="selectedStep">
      <div class="d-flex gap-3 mb-3">
        <div>
          <small class="border rounded-pill px-2">
            <i class="bi bi-stopwatch"></i>
            {{ selectedStep.duration }}
          </small>
        </div>
        <div *ngIf="selectedStep?.completed" class="d-flex gap-2 mb-3">
          <small
            class="border rounded-pill px-2 bg-success-subtle text-success"
          >
            <i class="bi bi-check-circle-fill me-1"></i>
            {{ selectedStep.type }}
          </small>
        </div>
      </div>

      <div class="border rounded px-3 py-2 bg-light">
        <h6>
          <span class="me-1"
            ><i class="bi bi-book" style="color: #6f42c1"></i></span
          >Overview
        </h6>
        <small class="text-muted">
          {{ selectedStep.overview }}
        </small>
      </div>

      <div *ngIf="selectedStep?.topicstoCover?.length" class="mt-4">
        <h6>
          <span class="me-1"
            ><i class="bi bi-bullseye" style="color: #6f42c1"></i></span
          >Topics to Cover
        </h6>
        <div class="d-flex flex-wrap gap-2">
          <span
            class="topic-pill"
            *ngFor="let topic of selectedStep.topicstoCover"
          >
            <small>
              {{ topic }}
            </small>
          </span>
        </div>
      </div>

      <h6 class="mt-4">Key Learning Points</h6>
      <ol class="custom-ol">
        <li *ngFor="let point of selectedStep.keyPoints; let i = index">
          <span class="number-circle">{{ i + 1 }}</span>
          <small class="point-text text-secondary">{{ point }}</small>
        </li>
      </ol>

      <div
        *ngIf="selectedStep?.proTips?.length"
        class="pro-tips-box mt-4 bg-warning-subtle p-3 rounded"
      >
        <h6 Pro Tips</h6>
        <ul class="list-unstyled">
          <li *ngFor="let tip of selectedStep.proTips">
            <small class="text-secondary">{{ tip }}</small>
          </li>
        </ul>
      </div>
    </div> 

  <div class="mx-2 border-top rounded py-2">
    <button class="btn w-100 mt-4" [ngClass]="
          selectedStep?.completed ? 'markasIncompleteBtn' : 'markAsCompletebtn'
        " (click)="toggleStepCompletion()">
      <i class="bi me-2" [ngClass]=""></i>
      {{
      selectedStep?.completed ? "Mark as Incomplete" : "Mark as Complete"
      }}
    </button>
  </div>
</div> -->